<div class="modal-header">
  <h2 mat-dialog-title [innerHTML]="data.title"></h2>
  <button type="button" class="close-button" mat-dialog-close aria-label="Close modal"><span class="ion-android-close" area-hidden="true"></span></button>
</div>
<mat-dialog-content>
  <p [innerHTML]="data.message"></p>
  <p [innerHTML]="data.question"></p>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    type="button"
    class="button secondary"
    (click)="cancel()"
  >
    {{data.cancelText}}
  </button>
  <button
    type="button"
    class="button"
    [ngClass]="{'action-alert': !data.isPlainMessage, 'action': data.isPlainMessage}"
    (click)="confirm()"
  >
    {{data.confirmText}}
  </button>
</mat-dialog-actions>
